export enum AccountSummaryFlowName {
  users = 'users',
}

export enum AccountSummaryFlowTitle {
  myAccount = 'Minha conta',
  editProfile = 'Editar cadastro',
}
